import { SortDirection } from '@tanstack/react-table';
import { Icon, IconProps } from '@toggle/design-system';
import { FC } from 'react';
import styled from 'styled-components';

export const SortIcon = styled<FC<IconProps & { $isSorted: SortDirection }>>(
  Icon
).attrs(props => ({
  iconName: props.$isSorted === 'asc' ? 'SortAscRight' : 'SortDescRight',
}))`
  fill: var(--icon-primary);
`;

export const PinIcon = styled(Icon).attrs({ iconName: 'Pin' })`
  fill: var(--icon-disabled);
`;
